var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonCheckboxTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-754.000000, -367.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M759.964673,375.50021 L754.905666,370.562562 L754,371.446502 L759.497883,376.812496 C759.625957,376.937499 759.790622,377 759.955287,377 C760.110804,377 760.275469,376.946427 760.394396,376.830357 L770,367.901814 L769.112648,367 L759.964673,375.50021 Z",
    id: "Fill-2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonCheckboxTick);
export default __webpack_public_path__ + "static/media/button-checkbox-tick.afd12bee737b3a58c58b7688517c9644.svg";
export { ForwardRef as ReactComponent };